import { v4 as getNS, v5 as uuidNameSpace } from 'uuid';
import { computed, ref } from 'vue';
import {
  type GetOrdersReconciliationFiltersQuery,
  type GetOrdersReconciliationFiltersQueryVariables,
  type GetOrdersReconciliationQuery,
  type GetOrdersReconciliationQueryVariables,
  type ReconcileContractForPeriodMutation,
  type ReconcileContractForPeriodMutationVariables,
  useGetOrdersReconciliationFiltersQuery,
  useGetOrdersReconciliationQuery,
  useReconcileContractForPeriodMutation,
} from '@/graphql/generated';

const RequestNameSpace = getNS();

const reconciliations = ref<GetOrdersReconciliationQuery['ordersReconciliation']>();
const reconciliationFilters = ref<GetOrdersReconciliationFiltersQuery['ordersReconciliationFilters']>();
const reconciliationStatus =
  ref<ReconcileContractForPeriodMutation['reconcileContractForPeriod']['contractReconciliation']>();

const operations = computed(() => reconciliations.value?.operations);

export const useReconciliationStore = () => {
  const getReconciliations = async (input: GetOrdersReconciliationQueryVariables) => {
    const { request } = useGetOrdersReconciliationQuery(input, {
      requestTrackerId: uuidNameSpace('get-reconciliations', RequestNameSpace),
    });

    const response = await request();

    if (response.data) {
      reconciliations.value = response.data.ordersReconciliation;
    } else {
      reconciliations.value = undefined;
    }
  };

  const getReconciliationFilters = async (input: GetOrdersReconciliationFiltersQueryVariables) => {
    const { request } = useGetOrdersReconciliationFiltersQuery(input);

    const response = await request();

    if (response.data) {
      reconciliationFilters.value = response.data.ordersReconciliationFilters;
    } else {
      reconciliationFilters.value = undefined;
    }
  };

  const completePeriodReconciliation = async (input: ReconcileContractForPeriodMutationVariables) => {
    const { request } = useReconcileContractForPeriodMutation(input);

    const response = await request();

    if (response.data) {
      reconciliationStatus.value = response.data.reconcileContractForPeriod.contractReconciliation;
    } else {
      reconciliationStatus.value = undefined;
    }
  };

  const clearReconciliations = () => {
    reconciliations.value = undefined;
  };

  const clearReconciliationFilters = () => {
    reconciliationFilters.value = undefined;
  };

  const clearReconciliationStatuses = () => {
    reconciliationStatus.value = undefined;
  };

  const clearAll = () => {
    clearReconciliations();
    clearReconciliationFilters();
    clearReconciliationStatuses();
  };

  return {
    reconciliations,
    operations,
    getReconciliations,
    getReconciliationFilters,
    reconciliationFilters,
    completePeriodReconciliation,
    reconciliationStatus,
    clearAll,
  };
};
